"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = void 0;
var schema = {
  type: "object",
  required: ["page_site", "page_sitecountry", "page_pagetitle", "page_pagetype", "page_sitesubsection", "page_sitesection"],
  additionalProperties: false,
  properties: {
    page_site: {
      "enum": ["28d-web", "lfs-web", "gemf-web", "gemvisa-web", "gomaster-web", "intfree-web", "buyersedge-web", "umiloans-web", "mobile-app", "cc-funnel", "pl-funnel", "ml-funnel", "shared-react", "lfs-checkout", "pl-quote", "resource-web", "kiwi-web"]
    },
    page_sitecountry: {
      "enum": ["au", "nz", "anz"]
    },
    page_pagetitle: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    page_pagetype: {
      "enum": ["home-page", "category-page", "product-details-page", "search-results-page", "error-page", "blog-page", "information-page", "calculator-page", "form-page", "login-page", "upload-page", "quote-page", "broker-page"]
    },
    page_sitesection: {
      "enum": ["home", "loans", "cards", "insurance", "interest-free", "calculators-and-tools", "osc", "information", "blog", "about-us", "search", "brokers", "latitude-pay", "latitude", "gem", "kiwibank", "error"]
    },
    page_sitesubsection: {
      type: "string"
    },
    page_sitesubsubsection: {
      type: "string"
    },
    product_productid: {
      uniqueItems: true,
      item: [{
        type: "array",
        "enum": ["CCAU28D", "CCAUGEM", "CCAUGOM", "CCAUAFS", "CCAUCLN", "CCAUAFF", "CCAULRM", "PLAULF-WEB", "MLAULF-WEB", "CCNZCLN", "CCNZGEM", "CCNZOCV", "PLNZLF-WEB", "MLNZLF-WEB", "BPAULFIBT", "BPAULFIST", "BPNZLFIBT", "BPNZLFIST", "INAUJLP", "INAULRP", "PLNZKB-WEB"]
      }]
    },
    event_category: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    event_action: {
      "enum": ["discovery-link", "application-link", "download", "livechat-started", "livechat-ended", "interaction", "external-link", "internal-link", "social-link", "phone-link", "email-link", "careers-link", "login", "application-started", "application-submitted", "application-cancelled", "application-navigation", "application-saved", "application-resumed", "poi-interaction", "idv-interaction", "error-loaded", "business-error", "technical-error", "form-started", "form-completed", "in-page-navigation", "service-centre-link", "quote-navigation", "quote-retrieval", "quote-retrieval-verify", "quote-link", "competition-link", "send-code", "quote-submitted", "quote-retrieval-link"]
    },
    event_label: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    event_location: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    event_value: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    event_loanproductselector: {
      type: "string",
      minLength: 1,
      maxLength: 255
    },
    trafficsource_internalsource: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    calculator_spendamount: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    broker_brokerid: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    broker_brokerfee: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_quoteid: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_quoteidinternal: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_currentloanexists: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_numberofapplicants: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_loanpurpose: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_loanamountrequested: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_loanduration: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_quoteretrieved: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_quotestatus: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_quotestartdate: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_quoteinterestrate: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_quoteoutcome: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    quote_quoteoutcomereason: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_personal_gender: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_personal_age: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_personal_firstname: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_personal_mobilenumber: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_personal_title: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_personal_hasdriverlicence: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_personal_residentialstatus: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_personal_emailaddress: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_employment_employmentstatus: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_employment_industrytype: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_address_postcode: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_address_suburb: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_address_state: {
      type: "string",
      minLength: 1,
      maxLength: 100
    },
    applicant_address_city: {
      type: "string",
      minLength: 1,
      maxLength: 100
    }
  }
};
exports.schema = schema;